module.exports = __webpack_public_path__ + "img/2.250813df.jpg";